import { render } from "./_id.vue?vue&type=template&id=3abd80fb&scoped=true"
import script from "./_id.vue?vue&type=script&lang=js"
export * from "./_id.vue?vue&type=script&lang=js"

import "./_id.vue?vue&type=style&index=0&id=3abd80fb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3abd80fb"

export default script